import { render } from "./validate.vue?vue&type=template&id=1373aa4e&scoped=true"
import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"

import "./validate.vue?vue&type=style&index=0&id=1373aa4e&scoped=true&lang=css"
import "./validate.vue?vue&type=style&index=1&id=1373aa4e&lang=css"
script.render = render
script.__scopeId = "data-v-1373aa4e"

export default script